import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  appBar: {
    background: `linear-gradient(
      90deg,
      ${theme.palette.primary.dark} 0%,
      ${theme.palette.primary.light} 100%
    );`,
  },
  listItemText: {
    '& span': {
      fontFamily: theme.font.medium,
      fontSize: '18px',
    },
  },
  toastContainer: {
    width: '520px',
  },
}));
